import {
  ProfileBoxListContentCenter,
  ProfileBoxListContentInfo,
  ProfileBoxListContentRight,
  ProfileBoxListDate,
  ProfileBoxListImage,
  ProfileBoxListLocation,
  ProfileBoxListSubTitle,
  ProfileBoxListTitle,
  ProfileBoxListWrapper,
} from './ProfileBoxListItem.styled';

import Button from '@components/atoms/button/Button';
import Image from '@components/atoms/image/Image';
import PropTypes from 'prop-types';
import React from 'react';
import String from '@components/atoms/string/String';
import { format } from 'date-fns';

const ProfileBoxListItem = props => {
  const {
    type,
    image,
    title,
    location,
    dateStart,
    dateEnd,
    course,
    section,
    jobTitle,
    is_current,
    onClick,
    isCurrentUserProfile,
  } = props;

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  const startDate = convertUTCToLocalDate(dateStart);
  const endDate = convertUTCToLocalDate(dateEnd);

  const newStartDate = format(startDate, 'MMMM yyyy');
  const newEndDate = format(endDate, 'MMMM yyyy');

  const Dates = () => {
    if (is_current) {
      return (
        <ProfileBoxListDate>
          {`From ${newStartDate} To Today `}
        </ProfileBoxListDate>
      );
    }
    return (
      <ProfileBoxListDate>
        {newStartDate === newEndDate ? (
          `${newStartDate}`
        ) : (
          <>
            <String id="profile_resume_input_label_from" /> {newStartDate}{' '}
            <String id="profile_resume_input_label_to" /> {newEndDate}
          </>
        )}
      </ProfileBoxListDate>
    );
  };
  `${(<String id="profile_resume_input_label_from" />)} ${newStartDate} ${(
    <String id="profile_resume_input_label_to" />
  )} ${newEndDate} `;

  const imageURL = CDN_URL + image?.path;

  const hasImage = section === 'recent_work';

  return (
    <ProfileBoxListWrapper hasImage={hasImage}>
      {hasImage && (
        <ProfileBoxListImage type={type}>
          {image ? (
            <img src={imageURL} alt={title} />
          ) : (
            <img
              alt={title}
              src="data:image/png;base64,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"
            />
          )}
        </ProfileBoxListImage>
      )}
      <ProfileBoxListContentCenter>
        <ProfileBoxListContentInfo>
          <ProfileBoxListTitle>{title}</ProfileBoxListTitle>
          <ProfileBoxListLocation>{location}</ProfileBoxListLocation>
          <ProfileBoxListSubTitle>{course || jobTitle}</ProfileBoxListSubTitle>
        </ProfileBoxListContentInfo>
        <Dates />
        <ProfileBoxListContentRight>
          {isCurrentUserProfile ? (
            <Button
              className="edit_icon"
              actionType="onclick"
              onClick={onClick}
              css={{
                marginLeft: '$12',
                width: '$32',
                height: '$32',
              }}
              svgIcon="edit"
              type="circle"
              circleSize="small"
              colorTheme="white"
            />
          ) : null}
        </ProfileBoxListContentRight>
      </ProfileBoxListContentCenter>
    </ProfileBoxListWrapper>
  );
};

export default ProfileBoxListItem;

// ProfileBoxListItem.propTypes = {
//   title: PropTypes.string,
//   subtitle: PropTypes.string,
//   image: PropTypes.shape({
//     src: PropTypes.string.isRequired,
//     srcset: PropTypes.string.isRequired,
//   }),
//   location: PropTypes.string,
//   date: PropTypes.string,
//   type: PropTypes.string,
// };

// ProfileBoxListItem.defaultProps = {
//   title: 'Moonlight',
//   subtitle: 'VFX Artist',
//   image: {
//     src: '/images/maya.jpg',
//     srcset: '/images/maya.jpg 1x,/images/maya.jpg  250w,/images/maya.jpg  500w',
//   },
//   location: '',
//   date: 'June to December 2019',
//   type: 'listThumbsSquare',
// };
